/* eslint-disable max-len */
import React, { SVGProps } from 'react';

type Props = Pick<SVGProps<SVGSVGElement>, 'width' | 'height'>;
const Gear: React.FC<Props> = (props: Props) => {
  const { width, height } = props;
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 1278.000000 1280.000000" preserveAspectRatio="xMidYMid meet">
      <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
        <path
          d="M5911 12790 c-409 -52 -565 -233 -603 -696 -11 -142 -7 -279 22 -754
  14 -210 0 -279 -67 -342 -45 -43 -108 -65 -278 -99 -208 -41 -259 -58 -530
  -184 -303 -140 -521 -232 -602 -253 l-65 -17 -35 40 c-20 22 -117 135 -217
  250 -368 427 -594 616 -802 670 -235 61 -449 -40 -738 -348 -441 -472 -472
  -510 -536 -642 -43 -91 -60 -159 -60 -246 0 -83 15 -139 66 -244 73 -153 152
  -245 502 -592 l326 -321 -34 -54 c-272 -428 -426 -760 -565 -1218 -57 -187
  -84 -244 -128 -267 -53 -28 -155 -32 -493 -21 -551 18 -724 -12 -875 -150 -95
  -87 -152 -208 -180 -382 -19 -113 -19 -819 -1 -930 58 -346 181 -505 453 -583
  154 -45 247 -51 741 -48 l457 2 11 -43 c101 -380 368 -970 535 -1184 139 -178
  154 -215 119 -290 -10 -20 -125 -138 -273 -278 -313 -297 -513 -502 -574 -588
  -128 -179 -161 -352 -98 -517 61 -160 345 -497 647 -765 285 -254 458 -338
  634 -308 206 35 394 175 708 527 121 135 550 587 563 593 4 2 72 -29 151 -69
  330 -165 652 -285 1023 -378 146 -37 203 -56 227 -78 21 -19 23 -61 7 -213
  -15 -149 -35 -1015 -27 -1134 23 -305 139 -489 359 -566 202 -71 582 -87 1079
  -45 274 23 360 53 476 169 109 108 166 236 197 441 33 214 32 360 -8 920 -8
  116 -18 258 -21 317 l-7 107 30 30 c22 22 57 38 134 61 266 80 466 147 604
  202 158 64 422 189 540 256 l70 40 90 -102 c204 -232 566 -627 650 -710 161
  -158 324 -272 455 -317 89 -30 224 -37 310 -15 81 21 199 84 269 144 129 110
  425 388 536 503 238 248 332 441 305 628 -15 98 -76 229 -159 338 -66 88 -251
  274 -416 419 -55 48 -143 126 -196 173 -52 47 -128 115 -168 150 -155 136
  -153 153 37 474 149 250 275 521 370 799 28 81 60 165 71 186 33 66 103 114
  206 143 68 19 349 17 575 -4 354 -33 489 -31 644 9 143 37 261 126 320 243 69
  135 99 384 99 811 1 389 -23 554 -103 727 -75 162 -213 247 -470 289 -114 19
  -439 21 -653 4 -78 -7 -205 -12 -282 -13 -157 -1 -193 8 -253 66 -49 47 -67
  88 -102 238 -56 236 -85 315 -181 490 -129 236 -244 474 -264 547 -25 95 -23
  183 6 230 13 22 124 129 246 240 401 365 554 558 608 767 19 76 19 204 0 280
  -20 78 -84 205 -140 280 -44 59 -278 315 -465 508 -224 232 -389 327 -569 327
  -248 0 -461 -151 -875 -620 -309 -351 -342 -377 -465 -368 -65 5 -140 39 -274
  125 -122 79 -243 129 -472 197 -379 112 -499 161 -585 242 -76 71 -75 66 -54
  377 49 730 2 1020 -201 1222 -132 132 -252 171 -570 185 -336 16 -664 20 -744
  10z m712 -4576 c422 -62 783 -229 1053 -487 260 -248 409 -532 475 -904 27
  -152 30 -456 5 -608 -59 -374 -204 -662 -458 -912 -143 -141 -259 -223 -457
  -322 -589 -296 -1396 -273 -1965 55 -192 110 -390 284 -509 444 -212 288 -317
  628 -317 1028 1 376 89 683 276 959 84 124 157 207 264 301 311 272 720 432
  1195 466 88 6 337 -5 438 -20z"
        />
      </g>
    </svg>
  );
};

export default Gear;
